import { NavLink } from "react-router-dom";

interface NavItem {
  to: string;
  label: string;
  icon: React.ReactNode;
}

function SyncIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
      <path d="M3 3v5h5" />
      <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" />
      <path d="M16 21h5v-5" />
    </svg>
  );
}

const NAV_ITEMS: NavItem[] = [
  { to: "/sync", label: "Sync", icon: <SyncIcon /> },
];

/** Mobile bottom navigation bar — shown only on screens narrower than lg. */
export default function NavBar() {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 lg:hidden bg-theme-raised border-t border-theme-subtle safe-area-pb">
      <div className="flex items-center justify-around px-2 py-1">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `flex flex-col items-center gap-0.5 px-4 py-2 rounded-lg text-xs font-medium transition-colors ${
                isActive
                  ? "text-brand-adaptive"
                  : "text-theme-muted hover:text-theme-secondary"
              }`
            }
          >
            {item.icon}
            <span>{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
